export default __webpack_public_path__ + "static/media/ponentes__Miriam Grunstein.f16df764.jpg";